import React from "react";
import { Button, Card, Modal, Col, Form, Input, Row, Switch, Cascader, DatePicker, notification } from "antd";
import { connect } from "react-redux";
import TableAvailableCoupons from "./TableAvailableCoupons";
import {fetchAvailableCoupons} from 'appRedux/actions/Reports'




class ModalCoupons extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,

    }
  }


  showModal = () => {
    this.setState({
      visible: true,
  
    });
  };
  onHandleCancel = () => {
    this.setState({ visible: false });
  }


  

  render() {

    return (
      <div>
        <Button type="danger" onClick={this.showModal}><i className="icon icon-ticket" /></Button>
        <Modal
          cancelText="Salir"
          title="Cupones disponibles"
          visible={this.state.visible}
          onCancel={this.onHandleCancel}
          onOk={this.onHandleCancel}
        >
          <TableAvailableCoupons coupon={this.props.recording.id}/>
        </Modal>
      </div>
    );
  }
}


export default ModalCoupons


// WEBPACK FOOTER //
// ./src/routes/main/Reports/balance/ModalCoupons.js